function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .ab651bbe-8e54-4bd1-bf58-8b9dd7417543{fill:#264653;}.b4a91433-8864-4001-a11f-12d426813517{fill:#2a9d8f;}.e07324dd-8ee3-4f72-a4a4-da1fa6be296b{fill:#fff;}.abdcb396-611e-4510-acb6-5dc53e00e4a6,.e07324dd-8ee3-4f72-a4a4-da1fa6be296b{stroke:#2a9d8f;stroke-linecap:round;stroke-linejoin:round;stroke-width:40px;}.abdcb396-611e-4510-acb6-5dc53e00e4a6{fill:none;}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "ab651bbe-8e54-4bd1-bf58-8b9dd7417543",
  d: "M98.13,845.55V597.89H13.5V555.12H236.26v42.77h-85V845.55Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "ab651bbe-8e54-4bd1-bf58-8b9dd7417543",
  d: "M303,607.87q-14.52,0-23.86-8.72a28.81,28.81,0,0,1-9.33-22,28.21,28.21,0,0,1,9.33-21.79q9.33-8.5,23.86-8.5t23.85,8.5a28.2,28.2,0,0,1,9.3,21.83,28.76,28.76,0,0,1-9.33,22Q317.56,607.88,303,607.87ZM276.5,845.55V639.79h53.13V845.55Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "ab651bbe-8e54-4bd1-bf58-8b9dd7417543",
  d: "M385.17,845.55V639.79h46.92l4.58,27.8A73,73,0,0,1,463,643.73q16.39-8.91,38-8.92,47.7,0,67.61,36.92a80,80,0,0,1,30.08-27,87.28,87.28,0,0,1,41.28-10q40.23,0,61.8,24.07t21.58,70.51V845.55H670.17V734.37q0-26.55-10.17-40.66t-31.31-14.1q-21.57,0-34.64,15.76t-13.06,44V845.55H527.85V734.37q0-26.55-10.37-40.66t-31.93-14.1q-21.17,0-34.22,15.76t-13.07,44V845.55Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "ab651bbe-8e54-4bd1-bf58-8b9dd7417543",
  d: "M873.83,850.52q-31.1,0-55.17-13.28a96,96,0,0,1-37.75-37.32q-13.68-24.07-13.68-55.6,0-31.94,13.48-56.83A97.85,97.85,0,0,1,818,648.71q23.84-13.89,56.21-13.9,30.27,0,53.51,13.27a95.54,95.54,0,0,1,36.29,36.29,102,102,0,0,1,13.06,51.23q0,4.56-.21,9.54c-.14,3.32-.34,6.77-.62,10.37H819.91q1.65,24,16.85,37.73t36.74,13.7q16.17,0,27.22-7.26a45,45,0,0,0,16.39-18.88H971a97.64,97.64,0,0,1-19.28,35.47,95.29,95.29,0,0,1-33.22,25.11Q898.71,850.52,873.83,850.52ZM874.25,678a56.61,56.61,0,0,0-34.44,11q-14.92,11-19.07,33.39H923.26Q922,702.07,908.33,690T874.25,678Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "ab651bbe-8e54-4bd1-bf58-8b9dd7417543",
  d: "M1189.5,845.55V597.89h-84.62V555.12H1327.6v42.77h-85V845.55Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "ab651bbe-8e54-4bd1-bf58-8b9dd7417543",
  d: "M1427.19,850.52q-29.87,0-53.71-13.69a100.4,100.4,0,0,1-37.75-38q-13.9-24.29-13.9-56.22t14.1-56.2a101.91,101.91,0,0,1,38-38q23.85-13.7,53.72-13.69,29.44,0,53.3,13.69a100.54,100.54,0,0,1,37.75,38q13.89,24.29,13.9,56.2t-13.9,56.22a100.2,100.2,0,0,1-38,38A106.1,106.1,0,0,1,1427.19,850.52Zm0-46q20.74,0,36.1-15.55t15.34-46.28q0-30.69-15.34-46.25t-35.68-15.55a48.85,48.85,0,0,0-36.29,15.55q-15.15,15.54-15.13,46.25t15.13,46.25q15.14,15.6,35.87,15.58Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "b4a91433-8864-4001-a11f-12d426813517",
  d: "M1699.77,855.92V405.27H1994v66.32H1782.18V595.2h192.49v64.37H1782.18v130H1994v66.31Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "b4a91433-8864-4001-a11f-12d426813517",
  d: "M2201.92,863.65q-42.49,0-74.69-13.84t-51.5-38.31a110.82,110.82,0,0,1-23.17-56.66h83q3.89,18.67,20.93,31.87t44.06,13.21q27,0,39.6-10.95t12.55-25.11q0-20.6-18-28t-50.2-14.49q-20.61-4.5-41.83-10.94A192.23,192.23,0,0,1,2103.74,694a84.76,84.76,0,0,1-28.65-25.75q-11-15.76-11-38.94,0-42.49,33.8-71.46t95-29q56.64,0,90.45,26.4T2323.5,628h-77.89q-7.09-35.38-53.43-35.4-23.19,0-35.73,9.07t-12.56,22.52q0,14.17,18.68,22.54t49.57,15.45q33.46,7.77,61.48,17t44.73,27.7q16.76,18.32,16.75,52.46a89.8,89.8,0,0,1-15.46,53.43q-16.09,23.84-46.35,37.33T2201.92,863.65Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "b4a91433-8864-4001-a11f-12d426813517",
  d: "M2539.9,855.92q-50.22,0-80.48-24.46t-30.26-86.91v-139H2374.5V536.61h54.71l9.67-85.63h72.74v85.63h86.27V605.5h-86.27V745.19q0,23.17,10,31.87t34.45,8.69H2596v70.17Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "b4a91433-8864-4001-a11f-12d426813517",
  d: "M2713.07,487q-22.56,0-37-13.52t-14.49-34.12q0-20.58,14.49-33.8t37-13.2q22.51,0,37,13.2t14.49,33.8q0,20.59-14.49,34.12T2713.07,487Zm-41.2,368.88V536.61h82.4V855.92Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "b4a91433-8864-4001-a11f-12d426813517",
  d: "M2840.5,855.92V536.61h72.74l7.09,43.14a113.32,113.32,0,0,1,40.87-37q25.43-13.83,58.9-13.84,74,0,105,57.3a124,124,0,0,1,46.65-41.85,135.28,135.28,0,0,1,64.06-15.45q62.45,0,95.9,37.34t33.49,109.44V855.92h-82.41V683.39q0-41.19-15.77-63.09t-48.64-21.89q-33.48,0-53.74,24.47t-20.28,68.23V855.92H3062V683.39q0-41.19-16.1-63.09t-49.57-21.89q-32.84,0-53.13,24.47t-20.25,68.23V855.92Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "b4a91433-8864-4001-a11f-12d426813517",
  d: "M3553.85,863.65q-41.22,0-67.6-13.2T3447,815.37a93.33,93.33,0,0,1-12.87-48.29q0-44.42,34.76-72.1t104.3-27.69h81.11v-7.78q0-32.82-18.68-48.27t-46.34-15.46q-25.11,0-43.78,11.91t-23.18,35.09h-80.47q3.21-34.77,23.5-60.52t52.45-39.54q32.17-13.83,72.09-13.84,68.23,0,107.56,34.12t39.27,96.57V855.92H3666.5l-7.78-51.51a118.93,118.93,0,0,1-39.56,42.53Q3593.75,863.65,3553.85,863.65Zm18.65-64.38q35.4,0,55-23.17t24.79-57.3h-70.18q-32.82,0-47,11.91T3521,760q0,18.69,14.16,29t37.34,10.3Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "b4a91433-8864-4001-a11f-12d426813517",
  d: "M3953,855.92q-50.2,0-80.48-24.46t-30.25-86.91v-139H3787.5V536.61h54.73l9.66-85.63h72.78v85.63h86.27V605.5H3924.7V745.19q0,23.17,10,31.87t34.44,8.69h39.92v70.17Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "b4a91433-8864-4001-a11f-12d426813517",
  d: "M4228.5,863.65q-48.26,0-85.61-20.6a149.08,149.08,0,0,1-58.59-57.95q-21.26-37.32-21.24-86.25,0-49.58,20.92-88.21a151.72,151.72,0,0,1,57.94-60.19q37-21.57,87.23-21.57,47,0,83,20.61a148,148,0,0,1,56.34,56.32q20.28,35.73,20.28,79.51c0,4.73-.12,9.66-.32,14.81s-.55,10.52-1,16.09H4144.84q2.59,37.35,26.08,58.58t57,21.26q25.09,0,42.17-11.28a69.69,69.69,0,0,0,25.41-29.29h83.7a151.66,151.66,0,0,1-29.94,55,147.6,147.6,0,0,1-51.55,39Q4267.14,863.65,4228.5,863.65Zm.65-267.82q-30.27,0-53.43,17.07t-29.62,51.84h159q-1.92-31.53-23.17-50.22t-52.8-18.69Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "e07324dd-8ee3-4f72-a4a4-da1fa6be296b",
  d: "M5135.3,380.27l-54-296.89a57,57,0,0,0-63.83-48.93L5005.64,36a57,57,0,0,0-48.91,63.84l38,274.08"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "e07324dd-8ee3-4f72-a4a4-da1fa6be296b",
  d: "M4881.23,447.91,4736.44,122a57,57,0,0,1,25.92-76.14l10.72-5.31a57,57,0,0,1,76.16,25.87l145.6,307.45"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "e07324dd-8ee3-4f72-a4a4-da1fa6be296b",
  d: "M4805.77,544.65,4587.37,262a54.54,54.54,0,0,1,10.52-76.14l9.13-6.9a54.58,54.58,0,0,1,76.18,10.49l198,258.49"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "e07324dd-8ee3-4f72-a4a4-da1fa6be296b",
  d: "M4805.29,544.84,4599.81,419.16a44.53,44.53,0,0,0-62.68,3.43l-6.23,7a44.49,44.49,0,0,0,3.43,62.63L4723.43,652l125.06,169.46L4980.3,948.34"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "abdcb396-611e-4510-acb6-5dc53e00e4a6",
  d: "M5094.47,776.68c-36.77-66.71-8.06-145.59,32-205.35a6.12,6.12,0,0,0,1.42-4.24c-3.53-10.62-4.23-20.88-8.11-30.43-37.15,5.28-73.24,10.91-111.1,16.54-12.39,1.76-23.7-3.2-34.31-10.28-1.06-.36-1.06-2.13-2.12-2.48-11.67-7.44-17.68-19.47-21.91-31.51-4.95-11.67-8.48-24.06-2.45-36.79,5.31-8.84,13.1-14.5,21.95-18,58.74-22.24,113.6-47,176.58-62.48,15.22-3.18,29,1.43,41.74,9.23,14.5,9.56,25.46,22.66,34.29,36.82,29.33,42.83,47,90.6,56.15,140.84,4.21,45.65,9.13,90.93,13.34,136.58,1.4,22.29,2.44,43.87,5.61,66.16a14.21,14.21,0,0,0,1.46,2.52"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a85992c0-ed98-47d2-8a23-96c7cbf9b3a1",
    "data-name": "b7e22f38-dd57-491a-b38b-a3126cb23ba0",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5400.85 974.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bfb1e67e.svg";
export { ForwardRef as ReactComponent };